import React from 'react'

const Breadcrumb = () => {
  return (
    <div>Breadcrumb</div>
  )
}

export default Breadcrumb